module.exports = __webpack_public_path__ + "img/40.adac345c.png";